module.exports = __webpack_public_path__ + "static/media/table_background_high.473e9e92.jpg";